import React from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  FormSelect,
  Card,
  CardHeader,
  CardBody,
  CardFooter
} from "shards-react";

import Chart from "../../utils/chart";

class CovidPieChart extends React.Component {
  constructor(props) {
    super(props);

    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    var stateData = [];
    fetch("https://data.covid19india.org/data.json")
    .then((res) => res.json())
    .then((data) => {
      const chartConfig = {
        type: "pie",
        data: {
          datasets: [
            {
              hoverBorderColor: "#ffffff",
              data: [data.statewise[0].deltaconfirmed, data.statewise[0].deltarecovered, data.statewise[0].deltadeaths],
              backgroundColor: [
                "rgba(0,123,255,0.7)",
                "rgba(23,198,113,0.7)",
                "rgba(255,65,105,0.7)"
              ]
            }
          ],
          labels: ["Confirmed", "Recovered", "Deaths"],
        options: {
          ...{
            legend: {
              position: "bottom",
              labels: {
                padding: 25,
                boxWidth: 20
              }
            },
            cutoutPercentage: 0,
            tooltips: {
              custom: false,
              mode: "index",
              position: "nearest"
            }
          },
          ...this.props.chartOptions
        }
      }
    }
    new Chart(this.canvasRef.current, chartConfig);
      
    })
    .catch(console.log);
  }


  

  render() {
    const { title } = this.props;
    return (
      <Card small className="h-100">
        <CardHeader className="border-bottom">
          <h6 className="m-0">{title}</h6>
        </CardHeader>
        <CardBody className="d-flex py-0">
          <canvas
            height="220"
            ref={this.canvasRef}
            className="blog-users-by-device m-auto"
          />
        </CardBody>
        <CardFooter className="border-top text-center text-semibold text-light">
          
        <span className=" text-center"> Stay Home, Stay Safe!</span>
        </CardFooter>
      </Card>
    );
  }
}

CovidPieChart.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
  /**
   * The chart config object.
   */
  chartConfig: PropTypes.object,
  /**
   * The Chart.js options.
   */
  chartOptions: PropTypes.object,
  /**
   * The chart data.
   */
  chartData: PropTypes.object
};

CovidPieChart.defaultProps = {
  title: "Today's Report",
  chartData: {
    datasets: [
      {
        hoverBorderColor: "#ffffff",
        data: [68.3, 24.2, 7.2, 0.32],
        backgroundColor: [
          "rgba(0,123,255,0.9)",
          "rgba(255,65,105,1)",
          "rgba(0,123,255,0.3)",
          "rgba(0,123,255,0.1)"
        ]
      }
    ],
    labels: ["Confirmed", "Recovered", "Deaths"]
  }
};

export default CovidPieChart;
